const STOREFRONT_API_TOKEN = "46d4dd68b608df364130eb665c3359ed";
const STOREFRONT_API_URL = "https://southbendclutch.myshopify.com/api/2023-07/graphql.json";

(function() {
  console.log("[Debug] custom-variant.js loaded!");

  var MAX_RETRIES = 20; // Stop after 2 seconds (20 x 100ms)
  var retryCount = 0;

  async function handleVariantChange(variant) {
    if (variant && variant.id) {
      console.log("[Debug] Variant Change Detected:", variant.id);
      await fetchVariantMetafields(variant.id);
      await refreshAllSections();
    }
  }

  function attachListener() {
    if (typeof jQuery === 'undefined') {
      retryCount++;
      if (retryCount < MAX_RETRIES) {
        setTimeout(attachListener, 100);
      }
      return;
    }

    var $productSection = jQuery('[data-section-type="product"]');
    if (!$productSection.length) {
      retryCount++;
      if (retryCount < MAX_RETRIES) {
        setTimeout(attachListener, 100);
      }
      // Not a product page - stop silently
      return;
    }

    // Attach directly to the product section
    $productSection.on('variantChange', function(event) {
      console.log("[Debug] variantChange event caught!", event.variant);
      handleVariantChange(event.variant);
    });
    console.log("[Debug] variantChange listener attached to product section:", $productSection[0].id);
  }

  function init() {
    const hpInit = document.getElementById("horsepower")?.getAttribute("data-target") || "";
    const tqInit = document.getElementById("torque")?.getAttribute("data-target") || "";
    updateSpecValues(hpInit, tqInit);

    attachListener();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

async function fetchVariantMetafields(variantId) {
  const variantGlobalId = `gid://shopify/ProductVariant/${variantId}`;
  const query = `
    query ($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          sku
          horsepower: metafield(namespace: "custom", key: "horsepower") { value }
          torque: metafield(namespace: "custom", key: "torque") { value }
          mpn: metafield(namespace: "custom", key: "mpn") { value }
        }
      }
    }
  `;

  try {
    const response = await fetch(STOREFRONT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_API_TOKEN
      },
      body: JSON.stringify({ query, variables: { id: variantGlobalId } })
    });

    const json = await response.json();
    const node = json?.data?.node || {};

    const hp = node?.horsepower?.value || "";
    const tq = node?.torque?.value || "";
    const sku = node?.sku || "";
    const mpn = node?.mpn?.value || "";

    console.log("[Debug] Retrieved HP:", hp, "TQ:", tq, "SKU:", sku, "MPN:", mpn);

    updateSpecValues(hp, tq);
    updateSkuMpn(sku, mpn);
  } catch (error) {
    console.error("[Debug] Error fetching variant metafields:", error);
  }
}

function updateSkuMpn(sku, mpn) {
  const skuEl = document.querySelector('.js-variant-sku');
  const mpnEl = document.querySelector('.js-variant-mpn');
  const mpnItem = document.querySelector('.sbc-meta-item--mpn');

  if (skuEl) {
    skuEl.textContent = sku || '—';
  }
  if (mpnEl) {
    mpnEl.textContent = mpn || '';
  }
  if (mpnItem) {
    mpnItem.style.display = mpn ? '' : 'none';
  }
}

function updateSpecValues(hp, tq) {
  const hpEl = document.getElementById("horsepower");
  const tqEl = document.getElementById("torque");

  if (hpEl) {
    hpEl.setAttribute("data-target", hp);
    hpEl.textContent = hp;
  }

  if (tqEl) {
    tqEl.setAttribute("data-target", tq);
    tqEl.textContent = tq;
  }
}

async function refreshAllSections() {
  await Promise.all([
    refreshSection("friction-material-snippet"),
    refreshSection("friction-material-content"),
    refreshSection("variant-metafield-tab"),
    refreshSection("clutch-level-content"),
    refreshSection("hub-style-content"),
    refreshSection("disc-style-content"),
    refreshSection("disc-quantity-content"),
    refreshSection("pressure-plate-modified-content"),
    refreshSection("clutch-stage-content")
  ]);
}

function refreshSection(id, callback = null) {
  return new Promise(resolve => {
    const el = document.getElementById(id);
    if (el) {
      el.innerHTML = "";
      $(el).load(location.href + ` #${id} > *`, () => {
        console.log(`[Debug] Section ${id} refreshed.`);
        if (typeof callback === "function") {
          callback();
        }
        resolve();
      });
    } else {
      console.warn(`[Debug] Section ${id} not found.`);
      resolve();
    }
  });
}
